import * as React from "react"
import { cn } from "../../lib/utils"

const Input = React.forwardRef(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        {...props}
        className={cn(
          "flex h-10 w-full rounded-md px-3 py-2 text-base md:text-sm transition-all duration-200",

          // -------- NORMAL STATE --------
          "border-[1.5px] border-input bg-background text-foreground placeholder:text-muted-foreground",

          // LIGHT MODE COLORS
          "border-[#D8C29A] bg-white text-black placeholder:text-[#B7AA93]",

          // DARK MODE COLORS
          "dark:border-[#5c4b2e] dark:bg-[#1b1a17] dark:text-white dark:placeholder:text-[#a99876]",

          // -------- HOVER --------
          "hover:border-[#C9A86A] hover:shadow-[0_0_0_4px_rgba(232,216,184,0.35)]",
          "dark:hover:border-[#d4b375] dark:hover:shadow-[0_0_0_4px_rgba(232,216,184,0.15)]",

          // -------- FOCUS --------
          "focus:border-[#C9A86A] focus:bg-white focus:shadow-[0_0_0_6px_rgba(232,216,184,0.65)] focus:outline-none focus:ring-0",
          "dark:focus:border-[#d4b375] dark:focus:bg-[#262421] dark:focus:shadow-[0_0_0_6px_rgba(232,216,184,0.4)]",

          // -------- DISABLED --------
          "disabled:bg-[#F7F1E6] disabled:cursor-not-allowed disabled:opacity-60",
          "dark:disabled:bg-[#2a2925]",

          // -------- FILE INPUT --------
          "file:border-0 file:bg-transparent file:text-sm file:font-medium",

          // -------- ERROR MODE --------
          error &&
            [
              "border-red-500 text-red-600 placeholder:text-red-500",
              "hover:border-red-500 focus:border-red-500",
              "focus:shadow-[0_0_0_6px_rgba(255,0,0,0.35)]",

              // DARK MODE ERROR
              "dark:border-red-400 dark:text-red-300 dark:placeholder:text-red-300",
              "dark:hover:border-red-400 dark:focus:border-red-400",
              "dark:focus:shadow-[0_0_0_6px_rgba(255,0,0,0.25)]",
            ],

          className
        )}
      />
    );
  }
);

Input.displayName = "Input";
export { Input };
